import React from "react";
import { OnboardingFormData } from "..";
import { Mail } from "iconoir-react";

interface InviteStepProps {
  formData: OnboardingFormData & { inviteEmail?: string };
  updateFormData: (
    data: Partial<OnboardingFormData & { inviteEmail?: string }>,
  ) => void;
  onNext: () => void;
  onSkip: () => void;
}

const InviteStep: React.FC<InviteStepProps> = ({
  formData,
  updateFormData,
}) => {
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData({ email: e.target.value });
  };

  return (
    <div className="flex flex-col items-center justify-center px-4 py-6 space-y-6 bg-pure-white">
      {/* Illustration - Hidden for now */}
      <div className="flex flex-col justify-center items-center gap-2.5">
        <img
          src="/icons/invite-illustration.svg"
          alt="Invite"
          className="w-34 h-34"
        />
      </div>

      {/* Title */}
      <div className="text-center">
        <h1 className="text-2xl font-semibold font-manrope text-midnight-blue leading-7">
          Mời bạn cùng phòng, <br />
          hàng xóm, hoặc người quen
        </h1>
      </div>

      {/* Email Input */}
      <div className="w-full max-w-sm">
        <div className="h-12 p-3.5 rounded-md outline outline-1 outline-offset-[-1px] outline-[#D1D1D0] flex items-center gap-2">
          <div className="size-5 relative overflow-hidden">
            <Mail className="w-5 h-5 text-midnight-blue/50" />
          </div>
          <input
            type="email"
            placeholder="Địa chỉ email"
            value={formData.email || ""}
            onChange={handleEmailChange}
            className="flex-1 bg-transparent outline-none text-midnight-blue/60 text-sm font-normal font-sora leading-tight"
          />
        </div>
      </div>

      {/* Divider */}
      <div className="text-center">
        <span className="text-xs font-normal font-sora text-midnight-blue/60">
          - Hoặc mời qua -
        </span>
      </div>

      {/* Social Sharing */}
      <div className="flex flex-col gap-4">
        <div className="flex justify-center items-center gap-4">
          <div className="flex flex-col items-center gap-3">
            <div className="px-5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-[#F4E7DA] flex items-center">
              <div className="size-6 relative bg-pure-white">
                <img className="size-6" src="/icons/message.png" />
              </div>
            </div>
            <span className="text-xs font-normal font-sora text-midnight-blue">
              Tin nhắn
            </span>
          </div>
          <div className="flex flex-col items-center gap-3">
            <div className="px-5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-[#F4E7DA] flex items-center">
              <div className="size-6 relative overflow-hidden">
                <img className="size-6" src="/icons/facebook.svg" />
              </div>
            </div>
            <span className="text-xs font-normal font-sora text-midnight-blue">
              Facebook
            </span>
          </div>
          <div className="flex flex-col items-center gap-3">
            <div className="px-5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-[#F4E7DA] flex items-center">
              <div className="size-6 relative">
                <img className="size-6" src="/icons/x.svg" />
              </div>
            </div>
            <span className="text-xs font-normal font-sora text-midnight-blue">
              X
            </span>
          </div>
        </div>
        <div className="flex justify-center items-center gap-4">
          <div className="flex flex-col items-center gap-3">
            <div className="px-5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-[#F4E7DA] flex items-center">
              <div className="size-6 relative">
                <img className="size-6" src="/icons/whatsapp.png" />
              </div>
            </div>
            <span className="text-xs font-normal font-sora text-midnight-blue">
              WhatsApp
            </span>
          </div>
          <div className="flex flex-col items-center gap-3">
            <div className="px-5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-[#F4E7DA] flex items-center">
              <div className="size-6 relative overflow-hidden">
                <img className="size-6" src="/icons/link.svg" />
              </div>
            </div>
            <span className="text-xs font-normal font-sora text-midnight-blue">
              Sao chép link
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteStep;
